import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import MunkakPage from "@/pages/MunkakPage";
import ReferenciakPage from "@/pages/ReferenciakPage";
import RolamPage from "@/pages/RolamPage";
import KapcsolatPage from "@/pages/KapcsolatPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/munkak" element={<MunkakPage />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/referenciak" element={<ReferenciakPage />} />
          <Route path="/rolam" element={<RolamPage />} />
          <Route path="/kapcsolat" element={<KapcsolatPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
